import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, signInWithGoogle, logout } from "./backend/firebase";



import Navbar from "./frontend/components/Navbar";
import Home from "./frontend/components/Home";
import About from "./frontend/components/About";
import HomeEducation from "./frontend/components/HomeEducation";
import Invest from "./frontend/components/Invest";
import InvestPage from "./frontend/components/InvestPage";
import Signup from "./frontend/components/Signup";
import Profile from "./frontend/components/Profile";
import SpecificInvest from "./frontend/components/SpecificInvest";
import InvestDef from "./frontend/components/Education/InvestDef";
import InvestRisk from "./frontend/components/Education/InvestRisk";
import InvestFactors from "./frontend/components/Education/InvestFactors";
import InvestPortfolio from "./frontend/components/Education/InvestPortfolio";
import StockDef from "./frontend/components/Education/StockDef";
import BuyAndSellStock from "./frontend/components/Education/BuyAndSellStock";
import StockFactors from "./frontend/components/Education/StockFactors";
import BondsDef from "./frontend/components/Education/BondsDef";
import BuyAndSellBonds from "./frontend/components/Education/BuyAndSellBonds";
import MutualFunds from "./frontend/components/Education/MutualFunds";
import StockFunds from "./frontend/components/Education/StockFunds";
import BondFunds from "./frontend/components/Education/BondFunds";
import MarketAndTargetFunds from "./frontend/components/Education/MarketAndTargetFunds";
import HedgeFunds from "./frontend/components/Education/HedgeFunds";
import SavingsDef from "./frontend/components/Education/SavingsDef";
import InterestFactors from "./frontend/components/Education/InterestFactors";
import InterestDef from "./frontend/components/Education/InterestDef";

function App() {
  /*
  const getData = async () => {
    const axios = require("axios");

    const options = {
      method: 'GET',
      url: 'https://bb-finance.p.rapidapi.com/market/auto-complete',
      params: {query: 'apple'},
      headers: {
        'X-RapidAPI-Key': '746493364cmshd780bef078ee5cfp19e65ajsnad619270b91f',
        'X-RapidAPI-Host': 'bb-finance.p.rapidapi.com'
      }
    };

    axios.request(options).then(function (response) {
      console.log(response.data);
    }).catch(function (error) {
      console.error(error);
    });
  }
  */
 
  const [user, loading, error] = useAuthState(auth);
  const [data, newData] = useState();
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) {
      // maybe trigger a loading screen
      return;
    }
    if (!user) navigate("/");
  }, [user, loading]);

  useEffect(() => {
    //getData()
  }, []);
  // const [user, setUser] = useState(null);

  // useEffect(()=> {
  //     auth().onAuthStateChanged(user => {
  //         setUser(user);
  //       })
  //     console.log(user)
  // }, [])
  //   useEffect(()=>{
  //     console.log(user)
  //   })

  return (
    <>
      <Routes>
        <Route path="/" element={<Home user={user} />} />
        <Route path="/login" element={<Signup />} />
        <Route path="/profile" element={<Profile user={user} />} />
        <Route path="/about" element={<About />} />
        <Route path="/homeeducation" element={<HomeEducation />} />
        <Route path="/invest" element={<Invest />} />
        <Route path="/investpage" element={<InvestPage />} />
        <Route path="/specificinvest" element={<SpecificInvest />} />
        <Route path="/InvestRisk" element={<InvestRisk />} />
        <Route path="/InvestDef" element={<InvestDef />} />
        <Route path="/InvestFactors" element={<InvestFactors />} />
        <Route path="/investportfolio" element={<InvestPortfolio />} />
        <Route path="/stockdef" element={<StockDef />} />
        <Route path="/buyandsellstock" element={<BuyAndSellStock />} />
        <Route path="/stockfactors" element={<StockFactors />} />
        <Route path="/bondsdef" element={<BondsDef />} />
        <Route path="/buyandsellbonds" element={<BuyAndSellBonds />} />
        <Route path="/mutualfunds" element={<MutualFunds />} />
        <Route path="/stockfunds" element={<StockFunds />} />
        <Route path="/bondfunds" element={<BondFunds />} />
        <Route
          path="/marketandtargetfunds"
          element={<MarketAndTargetFunds />}
        />
        <Route path="/hedgefunds" element={<HedgeFunds />} />
        <Route path="/savingsdef" element={<SavingsDef />} />
        <Route path="/interestdef" element={<InterestDef />} />
        <Route path="/interestfactors" element={<InterestFactors />} />
      </Routes>
    </>
  );
}

export default App;
